import { createFileRoute } from "@tanstack/react-router";
import CustomerAuth from "@/pages/CustomerAuth";

export const Route = createFileRoute("/community-login")({
  component: CustomerAuth,
});
